import {
  createClient as createUrqlClient,
  cacheExchange,
  fetchExchange,
  type ClientOptions,
  Client,
  mapExchange,
  makeOperation,
} from "@urql/vue";
import { getJwt } from "@/shared/auth/getJwt.helper";
import { isSuperUser } from "@/shared/auth/isSuperUser.helper";
import { getBackendPath } from "@/shared/helper/backendPath.helper";
import { getImpersonatedUserIdFromCookie } from "@/shared/helper/impersonationCookie.helper";
import { parallelQueryExchange } from "./parallelQueryExchange";

export const createUrqlConfig = (): ClientOptions => {
  return {
    url: getBackendPath("/api/graphql"),
    requestPolicy: "network-only",
    preferGetMethod: false,
    exchanges: [
      mapExchange({
        async onOperation(operation) {
          const jwt = await getJwt();
          const superUser = await isSuperUser();
          const impersonatedUserId = getImpersonatedUserIdFromCookie();

          return makeOperation(operation.kind, operation, {
            ...operation.context,
            fetchOptions: {
              headers: {
                ...(jwt && { Authorization: `Bearer ${jwt}` }),
                ...(superUser &&
                  impersonatedUserId && {
                    "X-Impersonated-User-Id": impersonatedUserId,
                  }),
              },
            },
          });
        },
      }),
      parallelQueryExchange,
      cacheExchange,
      fetchExchange,
    ],
  };
};

export const createClient = (): Client => createUrqlClient(createUrqlConfig());
